"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.024 20.978A6 6 0 0 1 13.5 21h-5a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7a4 4 0 0 1 4 3.999V15q0 .201-.013.4a6 6 0 0 1-5.463 5.577M18.1 14V6.999A2.6 2.6 0 0 0 15.5 4.4h-7A2.6 2.6 0 0 0 5.9 7v10a2.6 2.6 0 0 0 2.6 2.6h4.124v-2.9a2.7 2.7 0 0 1 2.7-2.7zm-4.077 5.57V16.7a1.3 1.3 0 0 1 1.3-1.3h2.76a4.6 4.6 0 0 1-4.06 4.17",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.127 9.991a.7.7 0 0 1-.99.025L12.702 8.65v4.569a.7.7 0 1 1-1.4 0V8.65l-1.437 1.366A.7.7 0 1 1 8.9 9.002l2.619-2.49a.7.7 0 0 1 .964 0l2.62 2.49a.7.7 0 0 1 .024.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PublishSheetIcon24.js.map